"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgGlossary = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconWrapper = _interopRequireWildcard(require("../../IconWrapper"));
var _excluded = ["title"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SvgGlossary = function SvgGlossary(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId;
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#glossary_svg__clip0_2005_58149)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.364 4.218a.6.6 0 01.6.6v13.818c0 .472.382.855.854.855h6.24a.6.6 0 110 1.2h-6.24a2.055 2.055 0 01-2.054-2.055V4.818a.6.6 0 01.6-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.764 4.818c0-1.135.92-2.054 2.054-2.054h12.364a.6.6 0 010 1.2H5.818a.855.855 0 000 1.709h12.364a.6.6 0 01.6.6v5.473a.6.6 0 01-1.2 0V6.873H5.818a2.055 2.055 0 01-2.054-2.055zM15.131 13.381a2.168 2.168 0 100 4.335 2.168 2.168 0 000-4.335zm-3.367 2.169a3.368 3.368 0 116.735-.002 3.368 3.368 0 01-6.735.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.667 17.084a.6.6 0 01.848 0l2.546 2.546a.6.6 0 01-.849.848l-2.545-2.545a.6.6 0 010-.849z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "glossary_svg__clip0_2005_58149"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 2)",
    d: "M0 0h18v19H0z"
  }))));
};
exports.SvgGlossary = SvgGlossary;
SvgGlossary.propTypes = {
  title: _propTypes["default"].string,
  titleId: _propTypes["default"].string
};
var GlossaryIcon = function GlossaryIcon(_ref2) {
  var title = _ref2.title,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(_IconWrapper["default"], props, /*#__PURE__*/React.createElement(SvgGlossary, {
    title: title || "Glossary Icon",
    titleId: "SvgGlossary-Id"
  }));
};
GlossaryIcon.propTypes = _IconWrapper.iconStylePropTypes;
var _default = GlossaryIcon;
exports["default"] = _default;